"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SummaryText = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  align-items: center;\n  /* Reset any margin from base styles */\n  margin: 0;\n  padding: ", ";\n\n  /* SummaryText is used instead of 'span' in case the user needs the first element to be a span */\n  > :first-child:not(", ") {\n    margin-right: ", ";\n  }\n\n  /* SummaryText is used instead of 'span' in case the user needs the last element to be a span */\n  > :last-child:not(", ") {\n    margin-left: auto;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)([""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

/**
 * This component was created because we can't apply styles to text nodes.
 * It is also used to set up right and left margins in `SummaryHeading`.
 */
var SummaryText = _styledComponents.default.span(_templateObject());

exports.SummaryText = SummaryText;

var SummaryHeading = _styledComponents.default.h2(_templateObject2(), function (props) {
  return props.padding;
}, SummaryText, function (props) {
  return props.marginRight;
}, SummaryText);

SummaryHeading.propTypes = {
  /** Adds margin-right onto the first element unless the first element is the `SummaryText` component  */
  marginRight: _propTypes.default.string,

  /** Sets padding for all four sides of the component */
  padding: _propTypes.default.string
};
SummaryHeading.defaultProps = {
  marginRight: '8px',
  padding: '0'
};
var _default = SummaryHeading;
exports.default = _default;